export default {
  namespaced: true,

  state: {           
        productOptions: [
            {id: 'S3D', name: 'Simcenter 3D'},
            {id: 'archived', name: 'Archived'}
        ]
  },
  getters: {},
  mutations: {},
  actions: {}
}

